import { useId } from 'react'

import { Switch } from '@components/atoms/Switch'
import cn from '@components/utils/cn'

type ToggleRowProps = {
  label: string
  description?: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
}

export function ToggleRow({ label, description, checked, onCheckedChange, disabled }: ToggleRowProps) {
  const id = useId()
  const descriptionId = `${id}-description`

  return (
    <div className="tw:flex tw:items-start tw:gap-3">
      <div className="tw:min-w-0 tw:flex-1">
        <label
          htmlFor={id}
          className={cn(
            'tw:m-0 tw:block tw:text-sm tw:font-medium',
            disabled ? 'tw:cursor-not-allowed tw:text-gray-500' : 'tw:cursor-pointer tw:text-gray-900'
          )}
        >
          {label}
        </label>
        {description && (
          <p id={descriptionId} className="tw:m-0 tw:mt-0.5 tw:text-xs tw:text-gray-true-500">
            {description}
          </p>
        )}
      </div>
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        aria-describedby={description ? descriptionId : undefined}
        disabled={disabled}
      />
    </div>
  )
}
